import Img1 from "../../assets/img/setting1.png";
import Img2 from "../../assets/img/setting2.png";
import Img3 from "../../assets/img/setting3.png";
import Img4 from "../../assets/img/setting4.png";

// Dashboard Type 

import CoporateImg from '../../assets/img/dashbordType/coporate.png';
import HospitalityImg from '../../assets/img/dashbordType/hospitality.png';
import VisitorImg from '../../assets/img/dashbordType/vistior.png';
import ServiceImg from '../../assets/img/dashbordType/service.png';

export const reportType = [
  {
    id: 1,
    title: "Feedback Overview",
    category: "Summary",
    icon: "overview",
    reportKey: "overview",
    subtitle: "See response volume, ratings, and customer sentiment at a glance.",
    insights: ["How satisfied are customers?", "Where is sentiment changing?", "Which forms need attention?"],
    path: "/generate-report/all-form-report/"
  },
  {
    id: 2,
    title: "Form Performance",
    category: "Compare",
    icon: "performance",
    reportKey: "performance",
    subtitle: "Compare completion, scores, and form-level strengths or gaps.",
    insights: ["Which form performs best?", "Where do customers drop off?", "Which questions underperform?"],
    path: null,
  },
  {
    id: 3,
    title: "Response Trends",
    category: "Trends",
    icon: "trends",
    reportKey: "trends",
    subtitle: "Track response activity, peak periods, and changes over time.",
    insights: ["When are response peaks?", "Is engagement improving?", "Which locations are growing?"],
    path: "/report/detailed-report/"
  },
  {
    id: 4,
    title: "Response Data Export",
    category: "Export",
    icon: "responses",
    subtitle: "Export a clean workbook of responses and question answers.",
    insights: ["What did each customer answer?", "Which records need analysis?", "What data can teams share?"],
    path: null,
    type: "answer-report",
  },
  {
    id: 5,
    title: "Ticket Resolution",
    category: "Service",
    icon: "tickets",
    subtitle: "Review ticket status, resolution time, ownership, and escalations.",
    insights: ["How quickly are issues resolved?", "Which tickets are still open?", "Where do escalations occur?"],
    path: null,
    type: "ticket-resolution",
  },
  {
    id: 6,
    title: "Performance Comparison",
    category: "Compare periods",
    icon: "comparison",
    subtitle: "Compare business performance across forms, locations, and periods.",
    insights: ["What changed month over month?", "Which locations improved?", "Where should teams take action?"],
    path: "/full-comparison/",
    type: "comparison",
  },
  {
    id: 7,
    title: "Full Details",
    category: "Detailed report",
    icon: "responses",
    subtitle: "Inspect every response, question answer, ticket, and metric in one workbook.",
    insights: ["What did each person answer?", "Which questions need attention?", "What is in the full data export?"],
    path: "/full-details/",
    type: "full-details",
  },
  // {
  //   id: 4,
  //   title: " Report",
  //   img: "form 1 form 2",
  //   subtitle: "Lorem ipsume the best pseudo text to be written in the text are",
  // },
  
];
export const dashbordType = [
  { id: 1, title: "Corporate", img: CoporateImg },
  { id: 2, title: "Hospitality", img: HospitalityImg },
  { id: 3, title: " Visitor Dashboard", img:VisitorImg },
  { id: 4, title: " Service Center", img: ServiceImg },
  { id: 5, title: " Public FeedBack", img: VisitorImg },
];
export const data3 = [
  {
    id: 1,
    title: "Form Setting",
    img: Img1,
    subtitle: "Lorem ipsume the best pseudo text to be written in the text are",
  },
  {
    id: 2,
    title: "Text Setting",
    img: Img2,
    subtitle: "Lorem ipsume the best pseudo text to be written in the text are",
  },
  {
    id: 3,
    title: " Image Setting",
    img: Img3,
    subtitle: "Lorem ipsume the best pseudo text to be written in the text are",
  },
  {
    id: 4,
    title: " Device Setting",
    img: Img4,
    subtitle: "Lorem ipsume the best pseudo text to be written in the text are",
  },
];

export const brandData = [
  { id: 10, title: "Brand Image", key: "brand_img" },
  { id: 1, title: "Welcome Image", key: "welcome_img"},
  { id: 2, title: "Thankyou Image", key: "thankyou_img" },
];

export const feedbackData = [
  { id: 8, title: "FeedBack Banner Image", key:"open_feedback_mode_banner" },
  { id: 9, title: "Owner Image", key: "owner_image" },
];

export const ratingData = [
  { id: 3, title: "Star 1 Image", key: "rate_one" },
  { id: 4, title: "Star 2 Image", key: "rate_two" },
  { id: 5, title: "Star 3 Image", key: "rate_three" },
  { id: 6, title: "Star 4 Image", key: "rate_four" },
  { id: 7, title: "Star 5 Image", key: "rate_five" },
];


export const data = [
    {
      id: 1,
      title: "Date of Birth",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 2,
      title: "Date of Aniversary",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 3,
      title: "Bill Details",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 4,
      title: "Comment Below 3 Star",
      switch: true,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 5,
      title: "Compulsary Selfie",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 6,
      title: "Social Handles",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 7,
      title: "Skip Asking NSP",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 8,
      title: "Contact Details",
      switch: true,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 9,
      title: "Employee Section",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 10,
      title: "No Employee Mode",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 11,
      title: "Employee PIN",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 12,
      title: "Survey Mode",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 13,
      title: "Table No",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 14,
      title: "Bill No",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 15,
      title: "Amount",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 16,
      title: "Switch To Hindi",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 17,
      title: "Open Feedback Mode",
      switch: true,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 18,
      title: "Single Page Feedback",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 19,
      title: "Secure Setting",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 20,
      title: "Checklist Enable",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 21,
      title: "PIN Mode",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 22,
      title: "Launcher Mode",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 23,
      title: "Timer",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 24,
      title: "Name",
      switch: true,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 25,
      title: "Phone Number",
      switch: true,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 26,
      title: "Email Address",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 27,
      title: "Advertisement",
      switch: false,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
    {
      id: 28,
      title: "Mutiple Form",
      switch: true,
      para: "form 1 form 2",
      para1: "Form name where input are taken",
    },
  ];
